import localStorageHelper from "../localStorageHelper";
export const RELOAD_REQUESTED = 'global/RELOAD_REQUESTED';
export const REPORT_COUNT = 'global/REPORT_COUNT';
export const SEARCH_PRESCRIPTION = 'global/SEARCH_PRESCRIPTION';
export const SHOW_SERVER_ERROR = 'global/SHOW_SERVER_ERROR';
export const HIDE_SERVER_ERROR = 'global/HIDE_SERVER_ERROR';

const initialState = {
    reloadState: false,
    reportCountState: 0,
    searchPrescription: null,
    serverError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RELOAD_REQUESTED:
            return {
                ...state,
                reloadState: true
            };
        case REPORT_COUNT:
            return {
                ...state,
                reportCountState: action.payload
            };
        case SEARCH_PRESCRIPTION:
            return {
                ...state,
                searchPrescription: action.payload
            };
        case HIDE_SERVER_ERROR:
            return {
                ...state,
                serverError: false
            };
        case SHOW_SERVER_ERROR:
            return {
                ...state,
                serverError: action.payload
            };
        default:
            return state
    }
}

export const reload = () => {
    return dispatch => {
        dispatch({
            type: RELOAD_REQUESTED
        });
    }
};


export const refreshServerError = () => {
    return dispatch => {
        dispatch({
            type: HIDE_SERVER_ERROR
        });
    }
};

export const serverError = (payload) => {
    refreshServerError();
    localStorageHelper.clear();
    localStorageHelper.setItem("auth", false);
    return dispatch => {
        dispatch({
            type: SHOW_SERVER_ERROR,
            payload
        });
    }
};

export const reportCount = (payload) => {
    return dispatch => {
        dispatch({
            type: REPORT_COUNT,
            payload: payload
        });
    }
};

export const saveSearchPrescription = (payload) => {
    return dispatch => {
        dispatch({
            type: SEARCH_PRESCRIPTION,
            payload
        });
    }
};



// WEBPACK FOOTER //
// ./src/redux/global.js